import React, { useState } from "react"
import classes from "./CopyLinkBtn.module.css"
import checkIcon from '../../../../assests/MaterialLibrary/check.png';
import { useSelector } from "react-redux";
import CheckBox from "../../CheckBox";

const CopyLinkBtn = ({ title, url, width, checked, setChecked, checkboxText }) => {

    const texts = useSelector(state => state.translate.texts);
    const [linkCopied, setLinkCopied] = useState(false);
    const direction = useSelector(state => state.translate.direction);


    const copyLink = (e) => {
        e.stopPropagation();
        navigator.clipboard.writeText(url);
        setLinkCopied(true);
    }


    return (
        <div className={`${classes[direction]} ${classes.CopyLink}`}>
            <div className={classes.SuccessIconAndText}>
                {linkCopied && <>
                    <img src={checkIcon} className={classes.SuccessIcon} alt="CheckIcon" />
                    <p className={classes.SuccessText}>{texts.theLinkExcutedAndCopied}</p>
                </>}
            </div>
            <div>
                <div className={classes.Title}> {title}</div>
                {setChecked && <CheckBox
                    checked={checked}
                    onChecked={() => setChecked(checked => !checked)}
                    onRemoveChecked={() => setChecked(checked => !checked)}>
                    <div>{checkboxText}</div>
                </CheckBox>}
                <div className={classes.CopyLinkContainer}>
                    <div className={classes.Link} style={{ width: width }}>{url}</div>
                    <button className={classes.Button} onClick={e => copyLink(e)}>
                        <div className={classes.ButtonIcon}></div>
                        <div>  {texts.copyLink}</div>
                    </button>
                </div>
            </div>
        </div>
    )
}
export default CopyLinkBtn